export default {
  // 共通
  QUESTIONNAIRE_REQUEST_TITLE: "問卷請求",
  QUESTIONNAIRE_REQUEST_DESCRIPTION: "為了提升服務品質，我們決定進行問卷調查。若您能協助我們，我們將不勝感激。",
  QUESTIONNAIRE_TEXT_AREA_PLACEHOLDER: "如果您選擇了“其他”，請在此處填寫詳細信息。",
  SEND_QUESTIONNAIRE: "提交調查問卷",
};
